import { render, staticRenderFns } from "./RoleEditPage.vue?vue&type=template&id=0af333fc"
import script from "./RoleEditPage.vue?vue&type=script&lang=js"
export * from "./RoleEditPage.vue?vue&type=script&lang=js"
import style0 from "./RoleEditPage.vue?vue&type=style&index=0&id=0af333fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports